import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import { ISelectOptions } from 'src/components/ui/Select/createSelect.types';

import { IFlowData } from '../components/ui/Form/types';

export const convertFilterToArray = <T>(field: T | string): string[] | undefined => {
  if (isArray(field)) {
    return field;
  }
  if (typeof field === 'string') {
    return [field];
  }
  return undefined;
};

export const convertFilterFieldToArray = (field: IFlowData): IFlowData[] | undefined => {
  if (isArray(field) && !isEmpty(field)) {
    return field;
  }
  if (isObject(field) && !isEmpty(field)) {
    return [field];
  }
  return undefined;
};

export const convertStringArrToSelectFilter = (data: string[]): ISelectOptions[] => {
  const result: ISelectOptions[] = data.map((item) => ({
    value: item,
    label: item,
  }));

  return result;
};
